type NodeLike = { data?: { questionId?: unknown } };

export const findCollidingQuestionIds = (nodes: readonly NodeLike[]): Set<string> => {
  const counts = new Map<string, number>();
  for (const node of nodes) {
    const value = node?.data?.questionId;
    if (typeof value !== 'string' || value.length === 0) continue;
    counts.set(value, (counts.get(value) ?? 0) + 1);
  }
  const collisions = new Set<string>();
  for (const [value, count] of counts) {
    if (count >= 2) collisions.add(value);
  }
  return collisions;
};
